module.exports = __webpack_public_path__ + "static/assets/15a7b793110951cfef352478c2d2642d.svg";